import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    matchCount: ({ count }: {
        count: number;
    }) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Match count display with pluralization */
            matchCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }) => __intl__.intl().formatMessage({ id: "ItemDetailMatchesQS.matchCount?c=3aigqlcjhf60v", defaultMessage: "{count} {count, plural, one {match} other {matches}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
